import { inject, Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { map } from 'rxjs';

import { createEffectFactory } from '@core/ngrx-legacy';

import { ReportsPermissionsHttpClient } from './permissions.http-client';
import { ReportsPermissionsActions } from './permissions.store';

@Injectable()
export class ReportsPermissionsEffects {
  private readonly actions$ = inject(Actions);
  private readonly http = inject(ReportsPermissionsHttpClient);

  public effects = createEffectFactory(ReportsPermissionsActions, this.actions$);

  public fetch$ = this.effects(ReportsPermissionsActions.fetch, () =>
    this.http.fetchPermissions().pipe(map(permissions => ({ data: permissions }))),
  );
}
